import { useMutation, useQueryClient } from "react-query";

import { deleteDeploymentRepo, submitDeploymentRepo } from "@api";
import { useOrg } from "@hooks/useOrg";
import { RepoChanges } from "@types";

import { Repo } from "@pages/projects/types";

type UpdateRepoParams = {
  deploymentId: string;
  repo: Repo;
  repoChanges: RepoChanges;
};

export const useUpdateRepoMutation = () => {
  const queryClient = useQueryClient();
  const org = useOrg();

  return useMutation(
    ({ deploymentId, repo, repoChanges }: UpdateRepoParams) => {
      return submitDeploymentRepo(deploymentId, repo, repoChanges);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["repos", { org }]);
      },
    }
  );
};

type DeleteRepoParams = {
  deploymentId: string;
  repoPath: string;
};

export const useDeleteRepoMutation = () => {
  const queryClient = useQueryClient();
  const org = useOrg();

  return useMutation(
    ({ deploymentId, repoPath }: DeleteRepoParams) => {
      return deleteDeploymentRepo(deploymentId, repoPath);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["repos", { org }]);
      },
    }
  );
};
